"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var IconLock = function IconLock(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    className: "'IconLock icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M8.782,0a6.2,6.2,0,0,1,6.372,5.725l0,.218,0,3.009h.647a2.133,2.133,0,0,1,2.186,1.893L18,10.99v8.961a2.1,2.1,0,0,1-2.03,2.036l-.156.005L2.191,22A2.135,2.135,0,0,1,.005,20.1L0,19.959V11A2.106,2.106,0,0,1,2.03,8.962l.156-.005.678,0L2.859,5.943A5.786,5.786,0,0,1,8.782,0ZM9,13.75a.7.7,0,0,0-.5.2.666.666,0,0,0-.191.379l-.006.108V15.8a.671.671,0,0,0,.2.489A.71.71,0,0,0,9,16.5a.7.7,0,0,0,.687-.6l.005-.093V14.44a.672.672,0,0,0-.2-.484A.71.71,0,0,0,9,13.75ZM5.146,6.319C5.214,4.141,6.412,2,9,2c2.663,0,3.856,2.27,3.856,4.511l0,2.445-7.709.005L5.143,6.517Z",
      transform: "translate(3 1)",
      fillRule: "evenodd"
    })
  });
};
var _default = IconLock;
exports["default"] = _default;